// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"styles-module__backdrop___FWY4a","dimmed":"styles-module__dimmed___Bni0Q","transparent":"styles-module__transparent___6EVxX"};